import { useEffect, useState } from "react";
import { FaPaperPlane } from "react-icons/fa6";
import { ModalWraper } from "../../../../../../../components/modal/wraper";
import { PopService } from "../../../../../../../services/PopService";
import { TextAreaDefault } from "../../../../../../../components/forms/TextAreaDefault";
import { InputDefault } from "../../../../../../../components/forms/InputDefault";
import { FaSave } from "react-icons/fa";
export const PopUpdateInfo = ({
    openModal,
    setOpenModal,
    data,
    refreshData,
}) => {
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        description: "",
    });

    useEffect(() => {
        setFormData({
            name: data.name,
            description: data.description,
        });
    }, [data]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await PopService.updateInfo({ id: data?.id, data: formData });
            refreshData();
            setOpenModal(false);
            setFormData({
                name: "",
                description: "",
            });
        } catch (error) {
            alert("Gagal menyimpan data.");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <ModalWraper
            isOpen={openModal}
            setIsOpen={setOpenModal}
            title="Update info POP"
        >
            <form
                onSubmit={handleSubmit}
                className="space-y-5"
            >
                <InputDefault
                    id="name"
                    label="Nama POP"
                    type="text"
                    placeholder="Cth: POP GADING"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />

                {/* Message */}
                <TextAreaDefault
                    id="description"
                    label="Deskripsi"
                    placeholder="Masukan deskripsi atau keterangan..."
                    value={formData.description}
                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                />

                <div className="flex gap-3">
                    <button
                        type="button"
                        onClick={() => setOpenModal(false)}
                        className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300 transition-colors hover:bg-slate-800"
                    >
                        Batal
                    </button>

                    <button
                        type="submit"
                        disabled={loading}
                        className="flex-1 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 disabled:bg-slate-700 text-white font-semibold flex items-center justify-center gap-2 transition-colors"
                    >
                        {loading ? (
                            <>Menyimpan...</>
                        ) : (
                            <>
                                <FaSave />
                                Simpan
                            </>
                        )}
                    </button>
                </div>
            </form>
        </ModalWraper>
    );
};